import { useRef } from "react";
import { useToast, type UseToastOptions } from "@chakra-ui/react";

// Create a custom toast function that ensures only one toast is shown at a time
export const useSingleToast = () => {
  const toast = useToast();
  const toastIdRef = useRef<string | number | undefined>();

  const showToast = (props: UseToastOptions) => {
    // Close any existing toast first
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }

    // Create a new toast and save its ID
    toastIdRef.current = toast({
      position: "top",
      isClosable: true,
      duration: 3000,
      ...props,
    });
  };

  return showToast;
};
